'use client'

import React from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface FilterProps {
  onValueChange: (val: string) => void
  items: { title: string; value: string }[]
  placeholder: string
  value: string
}

function Filter({ onValueChange, items, placeholder, value }: FilterProps) {
  return (
    <Select onValueChange={onValueChange} value={value}>
      <SelectTrigger className='border-secondary rounded-full text-foreground text-base px-4'>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {items.map((item) => (
          <SelectItem key={item.value} value={item.value}>
            {item.title}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export default Filter
